import React from "react";
import { Button } from "reactstrap";

function CustomButton(props) {
  return (
    <Button
      {...props}
      disabled={props.disabled||props.loading ? true: undefined}
      color={props.color || "dark"}
    >{" "}
      {props.loading && (
        <span
          className="spinner-border spinner-border-sm mr-2"
          role="status"
          aria-hidden="true"
        />
      )}
      {props.children}
    </Button>
  );
}

export default CustomButton;
